import React from 'react';
import './SnowWhite2026.css';

const SnowWhite2026 = () => {
  return (
    <div className="snowwhite-container">
      <div className="snowwhite-header">
        <h1>Snow White 2026</h1>
        <p>Dress Rehearsal</p>
      </div>     
  
      <div className="snowwhite-button-container">
        <a 
          href="https://photos.app.goo.gl/mPhMRqVEEDt344jU8" 
          target="_blank" 
          rel="noopener noreferrer"
          className="view-album-button"
        >
          View Full Album
        </a>
      </div>
      <div className="snowwhite-image-wrapper">
        <img 
          src="/images/snowwhite2026/SnowWhite2026-22.jpg" 
          alt="Snow White 2026" 
          className="snowwhite-holding-image"
        />
      </div>
      <div className="snowwhite-image-wrapper">
        <img 
          src="/images/snowwhite2026/SnowWhite2026-42.jpg" 
          alt="Snow White 2026 Group" 
          className="snowwhite-holding-image"
        />
      </div>
    </div>
  );
};

export default SnowWhite2026;
